import React from 'react';
export const HighlightSection = () => {
  return <section className="relative bg-gradient-to-b from-[#121212] to-[#0a0a0a] py-24" data-id="element-301">
      {/* Content */}
      <div className="relative z-10 max-w-screen-xl mx-auto px-6 sm:px-8 lg:px-12" data-id="element-302">
        <div className="max-w-3xl mx-auto text-center" data-id="element-303">
          <h2 className="text-4xl md:text-5xl font-bold text-white uppercase mb-6" data-id="element-304">
            The BK Signature <span className="text-[#D6281F]" data-id="element-305">Experience</span>
          </h2>
          <p className="text-[#CCCCCC] text-lg mb-10 leading-relaxed" data-id="element-306">
            Bij BKCustoms draait alles om jouw unieke wensen. We luisteren naar
            jouw visie en transformeren je auto met persoonlijke aandacht en
            precisie. Onze signature aanpak combineert vakmanschap met jouw
            persoonlijke stijl voor een resultaat dat écht bij jou past.
          </p>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-16" data-id="element-307">
            <div className="text-center" data-id="element-308">
              <div className="text-4xl font-bold text-[#D6281F] mb-2" data-id="element-309">
                Passie
              </div>
              <div className="text-white uppercase tracking-wider text-sm" data-id="element-310">
                Voor elk detail
              </div>
            </div>
            <div className="text-center" data-id="element-311">
              <div className="text-4xl font-bold text-[#D6281F] mb-2" data-id="element-312">
                Precisie
              </div>
              <div className="text-white uppercase tracking-wider text-sm" data-id="element-313">
                In elke afwerking
              </div>
            </div>
            <div className="text-center" data-id="element-314">
              <div className="text-4xl font-bold text-[#D6281F] mb-2" data-id="element-315">
                Persoonlijk
              </div>
              <div className="text-white uppercase tracking-wider text-sm" data-id="element-316">
                Van begin tot eind
              </div>
            </div>
          </div>
          <div className="mt-16" data-id="element-317">
            <a href="#portfolio" className="bg-[#D6281F] hover:bg-[#D6281F]/90 text-white px-8 py-4 uppercase tracking-wider font-medium transition-colors duration-300 inline-block" data-id="element-318">
              Bekijk Ons Portfolio
            </a>
          </div>
        </div>
      </div>
    </section>;
};